export {
  default as CRMStatusComponent,
  renderCRMStatusComponent,
} from './CRMStatusComponent';
export * from './config';
